import uft_images from './uft/images'
import uft_colors from './uft/colors'
import uft_fonts from './uft/fonts'
import ppr_images from './ppr/images'
import ppr_colors from './ppr/colors'
import ppr_fonts from './ppr/fonts'
import ufodrive_images from './ufodrive/images'
import ufodrive_colors from './ufodrive/colors'
import ufodrive_fonts from './ufodrive/fonts'
import demo_images from './demo/images'
import demo_colors from './demo/colors'
import demo_fonts from './demo/fonts'
import template_images from './template/images'
import template_colors from './template/colors'
import template_fonts from './template/fonts'
import hertz_images from './hertz/images'
import hertz_colors from './hertz/colors'
import hertz_fonts from './hertz/fonts'
import carvo_images from './carvo/images'
import carvo_colors from './carvo/colors'
import carvo_fonts from './carvo/fonts'
import acldrive_images from './acldrive/images'
import acldrive_colors from './acldrive/colors'
import acldrive_fonts from './acldrive/fonts'
import merchants_images from './merchants/images'
import merchants_colors from './merchants/colors'
import merchants_fonts from './merchants/fonts'
import outbound_images from './outbound/images'
import outbound_colors from './outbound/colors'
import outbound_fonts from './outbound/fonts'
import pritchards_images from './pritchards/images'
import pritchards_colors from './pritchards/colors'
import pritchards_fonts from './pritchards/fonts'
import configurations from '../config/configurations'

import rdbgroup_images from './rdbgroup/images'
import rdbgroup_colors from './rdbgroup/colors'
import rdbgroup_fonts from './rdbgroup/fonts'

import noleggioelettrico_images from './noleggioelettrico/images'
import noleggioelettrico_colors from './noleggioelettrico/colors'
import noleggioelettrico_fonts from './noleggioelettrico/fonts'

import maximobility_images from './maximobility/images'
import maximobility_colors from './maximobility/colors'
import maximobility_fonts from './maximobility/fonts'

import stellantis_images from './stellantis/images'
import stellantis_colors from './stellantis/colors'
import stellantis_fonts from './stellantis/fonts'

import stellantisppr_images from './stellantis-ppr/images'
import stellantisppr_colors from './stellantis-ppr/colors'
import stellantisppr_fonts from './stellantis-ppr/fonts'

let themeImages
let themeColors
let themeFonts

switch (configurations.UFO_APP_PLATFORM) {
  case 'ufodrive': {
    themeImages = ufodrive_images
    themeColors = ufodrive_colors
    themeFonts = ufodrive_fonts
    break
  }
  case 'ppr': {
    themeImages = ppr_images
    themeColors = ppr_colors
    themeFonts = ppr_fonts
    break
  }
  case 'uft': {
    themeImages = uft_images
    themeColors = uft_colors
    themeFonts = uft_fonts
    break
  }
  case 'template': {
    themeImages = template_images
    themeColors = template_colors
    themeFonts = template_fonts
    break
  }
  case 'demo': {
    themeImages = demo_images
    themeColors = demo_colors
    themeFonts = demo_fonts
    break
  }

  case 'hertz': {
    themeImages = hertz_images
    themeColors = hertz_colors
    themeFonts = hertz_fonts
    break
  }
  case 'hertz247': {
    themeImages = hertz_images
    themeColors = hertz_colors
    themeFonts = hertz_fonts
    break
  }
  case 'hertzch':
  case 'hertz247ie': {
    themeImages = hertz_images
    themeColors = hertz_colors
    themeFonts = hertz_fonts
    break
  }
  case 'acldrive': {
    themeImages = acldrive_images
    themeColors = acldrive_colors
    themeFonts = acldrive_fonts
    break
  }
  case 'merchants': {
    themeImages = merchants_images
    themeColors = merchants_colors
    themeFonts = merchants_fonts
    break
  }
  case 'carvo': {
    themeImages = carvo_images
    themeColors = carvo_colors
    themeFonts = carvo_fonts
    break
  }
  case 'outbound': {
    themeImages = outbound_images
    themeColors = outbound_colors
    themeFonts = outbound_fonts
    break
  }
  case 'pritchards': {
    themeImages = pritchards_images
    themeColors = pritchards_colors
    themeFonts = pritchards_fonts
    break
  }
  case 'noleggioelettrico': {
    themeImages = noleggioelettrico_images
    themeColors = noleggioelettrico_colors
    themeFonts = noleggioelettrico_fonts
    break
  }
  case 'rdbgroup': {
    themeImages = rdbgroup_images
    themeColors = rdbgroup_colors
    themeFonts = rdbgroup_fonts
    break
  }
  case 'maximobility': {
    themeImages = maximobility_images
    themeColors = maximobility_colors
    themeFonts = maximobility_fonts
    break
  }
  case 'stellantis': {
    themeImages = stellantis_images
    themeColors = stellantis_colors
    themeFonts = stellantis_fonts
    break
  }
  case 'stellantis-ppr': {
    themeImages = stellantisppr_images
    themeColors = stellantisppr_colors
    themeFonts = stellantisppr_fonts
    break
  }
  default: {
    themeImages = ufodrive_images
    themeColors = ufodrive_colors
    themeFonts = ufodrive_fonts
    break
  }
}

export const images = {
  confirmationApp: '/bookingApp/confirmationApp.png',
  confirmIcon: 'bookingApp/confirmIcon.png',
  logo: 'bookingApp/logo.png',
  ...themeImages
}
export const colors = themeColors
export const fonts = themeFonts
